<rt-form-field>
  <rt-label>
    {{ 'app.interview.schedule_dialog.send_at_kind_title' | translate }}
    <rt-badge color="pink-gradient" [text]="'app.common.new' | translate" margin-left-small-x />
  </rt-label>

  <rt-group variant="vertical">
    <rt-radio
      [hasColorTextColor]="true"
      [checked]="value() === 'on_day_of_event'"
      (click)="valueChange.emit('on_day_of_event')"
    >
      {{ 'app.interview.schedule_dialog.send_at_kind_on_event' | translate }}
    </rt-radio>
    <rt-radio
      [hasColorTextColor]="true"
      [checked]="value() === 'on_day_of_schedule'"
      (click)="valueChange.emit('on_day_of_schedule')"
    >
      {{
        (isSchedulerLink()
          ? 'app.interview.schedule_dialog.send_at_kind_on_schedule'
          : 'app.interview.schedule_dialog.send_at_kind_now'
        ) | translate
      }}
    </rt-radio>
  </rt-group>
</rt-form-field>
